<template>
  <div class="modal fade" id="keyAccountFilesUploadModal" tabindex="-1" role="dialog" aria-labelledby="keyAccountFilesUploadModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="keyAccountFilesUploadModalLabel">Files</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="custom-label">Upload Files</label>
            <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
              @vdropzone-success="fileUploaded"
              @vdropzone-sending="sendingEvent"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VueDropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'

  export default {
    props: ['url', 'type'],
    components: { VueDropzone },
    data() {
      return {
        dropzoneOptions: {
          url: '/',
          headers: {
            'X-CSRF-TOKEN': window.token,
          },
        }
      }
    },
    methods: {
      fileUploaded(file, res) {
        this.$emit('fileUploaded', {res, fileType: this.type})
      },
      sendingEvent(file, xhr, formData) {
        formData.append('type', this.type)
      },
    },
    mounted() {
      $('#keyAccountFilesUploadModal').on('show.bs.modal', () => {
        this.$refs.myVueDropzone.removeAllFiles()
      })
      $('#keyAccountFilesUploadModal').on('shown.bs.modal', () => {
        this.$refs.myVueDropzone.setOption('url', this.url);
      })
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/KeyAccountFilesUploadModal.vue